export default "__VITE_ASSET__BhGU8tpu__"